import { defaultHttpClient } from '../../httpClient';
import type { PostKakaoLoginRequest, PostKakaoLoginResponse } from './types';

/**
 * - 카카오 access_token으로 로그인하는 API
 * - 성공 시 멤버 JWT 토큰(token)을 반환한다.
 */
export const postKakaoLogin = (params: PostKakaoLoginRequest) => {
  return defaultHttpClient
    .request<PostKakaoLoginResponse>({
      method: 'POST',
      url: '/api/v2/login/kakao/',
      data: params,
    })
    .then(result => result.data);
};
